import { render, staticRenderFns } from "./GalleryCarouselItem.vue?vue&type=template&id=3a189128&scoped=true&"
import script from "./GalleryCarouselItem.vue?vue&type=script&lang=js&"
export * from "./GalleryCarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./GalleryCarouselItem.vue?vue&type=style&index=0&id=3a189128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a189128",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAvatar,VCarousel,VCarouselItem,VCol,VImg,VRow,VSheet})
